module.exports = __webpack_public_path__ + "static/media/aduana.dba96869.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/modelo/aduana.svg
// module id = 187
// module chunks = 0